export default __webpack_public_path__ + "static/PromptIconThree-609f239484435b8b00a5bc78d02f4d88.png";